import { useState } from "react";
import { categories, comics } from "@/mocks/comics";

export default function CategoryNav() {
  const [active, setActive] = useState("all");

  const current = active === "all" ? comics : comics.filter((c) => c.categoryId === active);

  return (
    <section id="category" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-900">
              <i className="ri-grid-fill text-primary-600"></i>
              分类目录
            </span>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              想看什么题材，一按就到
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              热血、都市、玄幻、科幻、悬疑……12 大题材分类，海量漫画全集按类归档，让你快速定位心仪作品。
            </p>
          </div>
          <a
            href="#hot"
            className="whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部漫画 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => setActive("all")}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              active === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
            }`}
          >
            全部
          </button>
          {categories.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => setActive(c.id)}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === c.id
                  ? "bg-primary-500 text-background-50"
                  : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
              }`}
            >
              <i className={c.icon}></i>
              {c.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {current.map((c) => (
            <a
              key={c.id}
              href="#hot"
              className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 p-3 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md">
                <img
                  src={c.cover}
                  alt={`${c.title} 封面`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <h3 className="truncate text-sm font-semibold text-foreground-950">{c.title}</h3>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{c.chapter}</p>
                <div className="mt-1 flex items-center gap-1 text-xs text-primary-600">
                  <i className="ri-fire-fill text-accent-500"></i>
                  {c.readers} 人看
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}